<template>
  <div class="image-container" ref="imageContainer">
    <img 
      ref="image"
      src="@/assets/NICOLE.NATURAL25(1).webp"
      alt="Imagen de ejemplo"
      class="cover-image"
    >
    <div class="overlay"></div>
    
    <div ref="textRef" class="text-overlay">
      <p class="firma">
        Con cariño,<br>
        <span>Nicole Rivera</span>
      </p>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null);
    const textRef = ref(null);
    const imageContainer = ref(null);

    onMounted(() => {
      // Creamos un timeline para que las animaciones sean consecutivas
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: imageContainer.value,
          start: "top 80%", // Comienza cuando el contenedor entra al 80% de la pantalla
          toggleActions: "play none none none"
        }
      });

      // 1. Animación de la imagen: Entrada suave con zoom out
      tl.fromTo(
        image.value,
        { 
          opacity: 0, 
          scale: 1.2,
          filter: 'brightness(0%)' 
        },
        { 
          opacity: 1, 
          scale: 1, 
          filter: 'brightness(80%)',
          duration: 1.8, 
          ease: 'expo.out' 
        }
      );

      // 2. Animación del texto: Aparece desde abajo con un ligero desenfoque
      tl.fromTo(
        textRef.value,
        { 
          opacity: 0, 
          y: 40,
          filter: 'blur(10px)' 
        },
        { 
          opacity: 1, 
          y: 0, 
          filter: 'blur(0px)',
          duration: 1.2, 
          ease: 'power3.out' 
        },
        "-=0.8" // Inicia 0.8 segundos antes de que termine la anterior (solapamiento elegante)
      );
    });

    return { textRef, image, imageContainer };
  },
};
</script>

<style scoped>
.image-container {
  width: 100%;
  height: 600px; /* Ajustado para mejor visibilidad en móviles */
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000; /* Fondo negro para que el fade-in se vea mejor */
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform, opacity;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Graduado sutil para que el texto resalte más */
  background: linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.4) 100%);
  z-index: 1;
}

.text-overlay {
  position: absolute;
  bottom: 60px; /* Subido un poco para que no quede pegado al borde en móviles */
  width: 100%;
  text-align: center;
  color: #fff;
  z-index: 10;
  padding: 0 20px;
}

.firma {
  font-size: 18px;
  font-family: 'Josefin Sans', sans-serif;
  font-weight: 400;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0,0,0,0.5);
}

.firma span {
  display: block;
  margin-top: 10px;
  font-family: 'FeelingPassionate', cursive;
  font-size: 3rem; /* Aumentado para que destaque en pantalla móvil */
  line-height: 1.2;
}

/* Ajuste específico para pantallas muy pequeñas */
@media (max-width: 480px) {
  .image-container {
    height: 700px;
  }
  .firma span {
    font-size: 2.5rem;
  }
}
</style>